// Home.tsx
import { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import styles from './Home.module.css';
import wankandoo from './img/wankandoo.png';
import { useAuth } from './AuthContext';
import { homePathForRole } from './utils/roleHome';

const Home = () => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const { isLoggedIn, userRole, loading } = useAuth();

  // Eingeloggte Nutzer haben auf der Landingpage nichts zu tun: direkt zur Kursliste.
  const home = isLoggedIn ? homePathForRole(userRole) : null;
  if (home) {
    return <Navigate to={home} replace />;
  }

  return (
    <div className={styles.homeContainer}>

      <div className={styles.decorativeWave}></div>

      <section className={styles.heroSection}>
        <div className={styles.imageContainer}>
          {!imageLoaded && <div className={styles.imagePlaceholder} />}

          <img
            src={wankandoo}
            alt="Wankandoo Logo"
            className={`${styles.heroLogo} ${imageLoaded ? styles.visible : ''}`}
            onLoad={() => setImageLoaded(true)}
          />
        </div>
        <h1 className={styles.heroTitle}>Willkommen bei Wankandoo.com!</h1>
        <p className={styles.heroSubtitle}>Dein intelligenter Stundenplan-Assistent</p>
        {!loading && !isLoggedIn && (
          <div className={styles.ctaRow}>
            <Link to="/login" className={styles.ctaPrimary}>Anmelden</Link>
            <Link to="/register" className={styles.ctaSecondary}>Konto erstellen</Link>
          </div>
        )}
      </section>

      <section className={styles.featuresSection}>
        <div className={styles.featureCard}>
          <div className={styles.featureIcon}>🧑‍🧒</div>
          <h3>Für Schüler und Meister</h3>
          <p>Damit beide Seiten entspannt durch's Semester kommen</p>
        </div>
        <div className={styles.featureCard}>
          <div className={styles.featureIcon}>🧘</div>
          <h3>Tiefenentspannt</h3>
          <p>Zen-Level Stundenplanung ganz ohne Schweißausbrüche</p>
        </div>
        <div className={styles.featureCard}>
          <div className={styles.featureIcon}>🌟</div>
          <h3>Ganzheitlich</h3>
          <p>Planen, Erstellen, Teilen, Verwalten - und Durchatmen</p>
        </div>

      </section>



      <div className={styles.decorativeBubbles}></div>
    </div>
  );
};

export default Home;
